<template>
  <b-field grouped>
    <button
      v-if="searchSelected"
      @click="removeSearch"
      class="button is-danger"
    >
      <b-icon size="is-small" pack="fas" icon="trash" />
    </button>
    <button v-else @click="showSaveSearch" class="button is-primary">
      <b-icon icon="content-save" />
    </button>
    <p class="control">
      <b-select v-model="selectedSavedSearch" expanded :loading="isLoading">
        <option
          v-for="savedSearch in savedSearches"
          :value="savedSearch"
          :key="savedSearch.id"
          >{{ savedSearch.name }}</option
        >
      </b-select>
    </p>
    <p class="control" v-if="searchSelected">
      <button @click="goToSavedSearch" class="button is-info">
        <b-icon size="is-small" pack="fas" icon="arrow-right" />
      </button>
    </p>
  </b-field>
</template>

<script>
import Fetcher from '@/mixins/fetcher.js'
import { mapActions } from 'vuex'
export default {
  name: 'AdminOnBoardRequestsTable',
  mixins: [Fetcher],
  props: {},
  data() {
    return {
      selectedSavedSearch: { id: null, name: null, query: null },
      searches: []
    }
  },
  computed: {
    searchSelected() {
      return this.selectedSavedSearch.id != null
    },
    savedSearches() {
      return [
        { id: null, name: this.$t('Búsquedas guardadas'), query: null }
      ].concat(this.searches)
    }
  },
  mounted() {
    let self = this
    self.unsetSelectedSearch()
    self.request(() =>
      self.getSavedSearches().then(function(response) {
        self.searches = response.data
      })
    )
  },
  methods: {
    ...mapActions('institutions', [
      'getSavedSearches',
      'postSaveSearch',
      'deleteSearch'
    ]),
    unsetSelectedSearch() {
      this.selectedSavedSearch = {
        id: null,
        name: this.$t('Búsquedas guardadas'),
        query: null
      }
    },
    goToSavedSearch() {
      let obj = Object.assign({}, this.$route.query)
      const query = JSON.parse(
        '{"' +
          decodeURI(this.selectedSavedSearch.query.substr(1))
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
          '"}'
      )
      Object.keys(query).forEach(key => {
        let value = query[key]
        if (value) {
          obj[key] = value
        } else {
          delete obj[key]
        }
      })
      this.$router.replace({
        ...this.$router.currentRoute,
        query: obj
      })
    },
    removeSearch() {
      let self = this
      const id = self.selectedSavedSearch.id
      self.$dialog.confirm({
        message: self.$t('¿Estás seguro? esta operación no se puede deshacer'),
        type: 'is-danger',
        onConfirm: function() {
          self.request(() =>
            self.deleteSearch(id).then(function(res) {
              const deletedSearchId = res.data.id
              self.searches = self.searches.filter(
                search => search.id != deletedSearchId
              )
              self.unsetSelectedSearch()
            })
          )
        }
      })
    },
    showSaveSearch() {
      let self = this
      self.$dialog.prompt({
        message: self.$t(`Nombre para la búsqueda`),
        inputAttrs: {
          placeholder: 'e.g. VC EEUU'
        },
        trapFocus: true,
        onConfirm: function(value) {
          self.request(() =>
            self
              .postSaveSearch({
                query: window.location.search,
                name: value
              })
              .then(function(response) {
                const newSavedSearch = response.data
                self.searches.push(newSavedSearch)
                self.selectedSavedSearch = newSavedSearch
              })
          )
        }
      })
    }
  }
}
</script>
